/** Placeholder image when a course has no thumbnail set. */
export const PLACEHOLDER_COURSE_IMAGE =
  'https://placehold.co/400x225/e2e8f0/64748b?text=Course';
